module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    on: {
      "mouseleave": function($event) {
        _vm.selectCategory(null, null, false)
      }
    }
  }, [_vm._l((_vm.categories), function(category, indexCat) {
    return _c('div', {
      key: indexCat,
      staticClass: "menu-btn w-100",
      style: (("background-color:" + (_vm.activeCategory(category) ? _vm.globalColors.border : 'white') + ";border-left: 1.5rem solid " + (_vm.activeCategory(category) ? _vm.globalColors.primary : 'white') + ";")),
      attrs: {
        "type": "button"
      },
      on: {
        "mouseenter": function($event) {
          _vm.selectCategory($event, category, true)
        },
        "click": function($event) {
          _vm.goToCategory(category)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": category.mobileImage
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "category-title"
    }, [_vm._v(_vm._s(category.title))])])
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-lateral",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onShowingMenu),
      expression: "onShowingMenu"
    }],
    staticClass: "hidden-menu absolute",
    on: {
      "mouseleave": function($event) {
        _vm.selectCategory(null, null, false)
      },
      "mouseover": function($event) {
        _vm.selectCategory(null, null, true)
      }
    }
  }, [_c('div', {
    staticClass: "wrapper-product-container"
  }, [_c('div', {
    staticClass: "grid-system"
  }, _vm._l((_vm.currentCategory.detail), function(item, indexItem) {
    return _c('div', {
      key: indexItem,
      staticClass: "product-container"
    }, [_c('div', {
      staticClass: "product-title-container",
      on: {
        "click": function($event) {
          _vm.goToCategory(item)
        }
      }
    }, [_c('p', {
      staticClass: "product-title",
      style: (("border-bottom: 0.2rem solid " + (_vm.globalColors.primary) + ";"))
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "product-description"
    }, [_c('img', {
      attrs: {
        "src": item.urlImage,
        "alt": "imagen de la Categpría"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.description))])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pointer absolute",
    style: (_vm.positioning)
  })])])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f672b4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menuWeb.vue
// module id = 486
// module chunks = 4 5 6 35